import {Component} from '@angular/core';
import {Setting} from '../models/setting';
import * as actions from '../actions/setting';
import * as fromRoot from '../reducers';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {PagingModel} from '../models/paging-model';

@Component({
  selector: 'app-admin-settings',
  template: `<div>
    <div class="row">
      <div class="col-md-7">
        <h2>Settings</h2>
      </div>
      <div class="col-md-5">
        <paging-header [paging]="paging$ | async" (countChanged)="changeNumberPerPage($event)"></paging-header>
      </div>
    </div>
    <setting-list [settings]="settings$ | async"></setting-list>
    <paging-footer [paging]="paging$ | async" (pageChanged)="changePageNumber($event)"></paging-footer>
  </div>
  `
})
export class AdminSettingsPageComponent {

  public settings$: Observable<Setting[]>;
  public paging$: Observable<PagingModel>;

  constructor(private store: Store<fromRoot.State>) {
    this.settings$ = this.store.select(fromRoot.getSettingPage);
    this.paging$ = this.store.select(fromRoot.getSettingPaging);
    this.store.dispatch(new actions.LoadAllSettingsAction(new PagingModel(25, 0, 0, 1)));
  }

  public changePageNumber(paging: PagingModel) {
    window.scrollTo(0, 0);
    this.store.dispatch(new actions.LoadAllSettingsAction(paging));
  }

  public changeNumberPerPage(paging: PagingModel) {
    this.store.dispatch(new actions.LoadAllSettingsAction(paging));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/admin-settings.ts